import { useMemo } from "react";
import { initialState } from "./slice";
import getIsUs from "utils/getIsUs";

const buildInitialState = (isUs) => {
    const state = window.structuredClone(initialState);

    const foundation = isUs ? ["Private Funders"] : ["Public & Private"];

    state["giving-history"].searchFilters.foundation = foundation;
    state["keywords"].searchFilters.foundation = foundation;
    state["name"].searchFilters.foundation = foundation;
    state["director"].searchFilters.foundation = foundation;
    state["year"].searchFilters.foundation = foundation;
    state["international-funding"].searchFilters.foundation = foundation;
    state["custom"].searchFilters.foundation = foundation;

    return state;
};

/**
 * Gets the initial search engine state for non-React usage.
 */
export const getInitialState = () => {
    return buildInitialState(getIsUs());
};

/**
 * Gets a memoized initial search engine state for React components/hooks.
 */
export const useInitialState = () => {
    const isUs = getIsUs();

    const initialStateValue = useMemo(() => buildInitialState(isUs), [isUs]);

    return { initialState: initialStateValue };
};
